import { Component } from '@angular/core';

@Component({
  selector: 'final-meeting-template',
  templateUrl: './final-meeting-template.component.html',
  styleUrls: ['../../../meeting-form.component.scss', '../../form-steps.scss']
})
export class FinalMeetingTemplateComponent {
  opened = false
}
